<template>
  <div class="m-converted-bonuses">
    <b-modal
      id="referrals-converted-bonuses-modal"
      v-model="localActive"
      size="custom-size"
      centered
      hide-footer
      hide-header
      @close="localActive = false"
    >
      <svg
        class="m-converted-bonuses-close"
        width="15"
        height="16"
        viewBox="0 0 15 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        @click="localActive = false"
      >
        <path
          d="M10.6045 11.5377C10.2154 11.9267 9.58272 11.9247 9.19126 11.5333L3.53712 5.88051C3.14565 5.48904 3.14367 4.85633 3.5327 4.4673C3.92172 4.07828 4.55443 4.08026 4.9459 4.47173L10.6 10.1245C10.9915 10.5159 10.9935 11.1486 10.6045 11.5377Z"
          fill="#8E9CBB"
        />
        <path
          d="M10.6127 4.47053C10.2212 4.07907 9.58849 4.07709 9.19947 4.46611L3.53718 10.1284C3.14816 10.5174 3.15014 11.1501 3.54161 11.5416C3.93307 11.9331 4.56579 11.9351 4.95481 11.546L10.6171 5.88374C11.0061 5.49471 11.0041 4.862 10.6127 4.47053Z"
          fill="#8E9CBB"
        />
      </svg>
      <div class="m-converted-bonuses-title">Конвертировать бонусы</div>
      <div class="m-converted-bonuses-description">
        Бонусы будут конвертированы в ฿ и переведены на личный счет сотрудника
      </div>
      <div
        :class="{ 'm-converted-bonuses-controls-required': countConvertedBonusesErrorMessageLocal.length > 0 }"
        class="m-converted-bonuses-controls"
      >
        <c-input
          v-model="countConvertedBonusesLocal"
          label="Бонусы"
          class="m-converted-bonuses-controls-input"
          :input-text-condition="countConvertedBonusesErrorMessageLocal"
          type="integer-number"
          :max-integer-value="countBonusesCurrent"
          placeholder="0"
        />
        <div class="m-converted-bonuses-controls-bonuses-in-rub">
          = {{ countConvertedBonusesLocal * bonusesRate }} <span>฿</span>
        </div>
        <div class="m-converted-bonuses-controls-buttons">
          <c-button class="m-converted-bonuses-controls-buttons-cancel" label="Отменить" @click="closeModal" />
          <c-button
            class="m-converted-bonuses-controls-buttons-convert"
            label="Конвертировать"
            color="primary"
            @click="submitConvert"
          />
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Input from "@/components/controls2/Input";
import Button from "@/components/controls2/Button";

export default {
  name: "referrals-converted-bonuses-modal",
  components: {
    "c-input": Input,
    "c-button": Button,
  },
  props: ["active", "countBonusesCurrent", "bonusesRate"],
  data() {
    return {
      localActive: false,
      countConvertedBonusesLocal: 0,
      countConvertedBonusesErrorMessageLocal: "",
    };
  },

  watch: {
    localActive(value) {
      if (!value) {
        setTimeout(() => {
          this.submitAttempt = false;
          this.countConvertedBonusesErrorMessageLocal = "";
          this.countConvertedBonusesLocal = this.countBonusesCurrent;
        }, 250);
        this.$emit("close");
      }
    },
    active(value) {
      this.localActive = value;
    },
    countBonusesCurrent(value) {
      setTimeout(() => {
        this.countConvertedBonusesLocal = value;
      }, 250);
    },
    countConvertedBonusesLocal(value) {
      if (this.submitAttempt) {
        if (value.length === 0) {
          this.countConvertedBonusesErrorMessageLocal = "Обязательное поле";
        } else {
          this.countConvertedBonusesErrorMessageLocal = "";
        }
      }
    },
  },

  methods: {
    closeModal() {
      this.localActive = false;
    },
    submitConvert() {
      this.submitAttempt = true;
      let isValid = true;
      if (this.countConvertedBonusesLocal.length === 0) {
        this.countConvertedBonusesErrorMessageLocal = "Обязательное поле";
        isValid = false;
      }

      if (isValid) {
        this.$store
          .dispatch("personalEmployee/convertBonusesInRub", {
            workerId: this.$route.params.id,
            userId: this.$store.state.userId,
            bonusValue: this.countConvertedBonusesLocal,
            realValue: this.countConvertedBonusesLocal * this.bonusesRate,
          })
          .then(() => {
            this.$emit("convertBonusesToRub", this.countConvertedBonusesLocal);
            this.closeModal();
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";
.m-converted-bonuses {
  position: relative;

  &-close {
    cursor: pointer;
    position: absolute;
    top: 12px;
    right: 10px;
  }

  &-title {
    font-weight: 500;
    font-size: 18px;
    line-height: 120%;

    @media screen and (max-width: 700px) {
      font-size: 15px;
      line-height: 120%;
    }
  }

  &-description {
    margin-top: 16px;
    font-size: 13px;
    line-height: 16px;

    @media screen and (max-width: 700px) {
      margin-top: 12px;
      font-size: 13px;
      line-height: 16px;
    }
  }

  &-controls {
    margin-top: 21px;
    display: flex;
    align-items: flex-end;

    @media screen and (max-width: 700px) {
      margin-top: 15px;
      padding-bottom: 57px;
    }

    &-required {
      margin-bottom: 14px;
    }

    &-input {
      max-width: 70px;

      @media screen and (max-width: 700px) {
        max-width: 50%;
        width: 100%;
      }
    }

    &-bonuses-in-rub {
      font-weight: 500;
      font-size: 15px;
      line-height: 100%;
      margin-bottom: 10px;
      margin-left: 15px;

      & span {
        font-size: 14px;
      }
    }

    &-buttons {
      display: flex;
      margin-left: 30px;

      @media screen and (max-width: 700px) {
        margin: 0;
        position: absolute;
        width: 100%;
        bottom: 0;
        left: 0;
      }

      &-cancel {
        background: #ffffff;
        max-width: 120px;

        @media screen and (max-width: 700px) {
          border-radius: 0;
          border-bottom: none;
          max-width: 50%;
          width: 50%;
          border-left: none;
        }
      }

      &-convert {
        margin-left: 10px;
        max-width: 167px;

        @media screen and (max-width: 700px) {
          width: 50%;
          max-width: 50%;
          margin-left: 0;
          border-radius: 0;
        }
      }
    }
  }
}
</style>
